export const formatKey = {
	'IP': 'In Person',
	'OTHER': 'Hybrid/Other',
	'ITV': 'ITV',
	'INTERNET': 'Online',
};

export const collegeKey = {
	'ASHLAND': 'Ashland Community and Technical College',
	'BIG SANDY': 'Big Sandy Community and Technical College',
	'BLUEGRASS': 'Bluegrass Community and Technical College',
	'ELIZABETHTOWN': 'Elizabethtown Community and Technical College',
	'GATEWAY': 'Gateway Community and Technical College',
	'HAZARD': 'Hazard Community and Technical College',
	'HENDERSON': 'Henderson Community College',
	'HOPKINSVILLE': 'Hopkinsville Community College',
	'JEFFERSON': 'Jefferson Community and Technical College',
	'MADISONVILLE': 'Madisonville Community College',
	'MAYSVILLE': 'Maysville Community and Technical College',
	'OWENSBORO': 'Owensboro Community and Technical College',
	'SOMERSET': 'Somerset Community College',
	'SOUTHCENTRAL': 'Southcentral Kentucky Community and Technical College',
	'SOUTHEAST': 'Southeast Kentucky Community and Technical College',
	'WEST KENTUCKY': 'West Kentucky Community and Technical College',
};

export const monthKey = {
	'01': 'January',
	'02': 'February',
	'03': 'March',
	'04': 'April',
	'05': 'May',
	'06': 'June',
	'07': 'July',
	'08': 'August',
	'09': 'September',
	'10': 'October',
	'11': 'November',
	'12': 'December',
};

export const instructionModeKey = {
	'BC': 'Blackboard Web Local Plato',
	'BE': 'Blackboard Web Enhanced Plato',
	'BI': 'ITV Classroom w/Online Content',
	'BK': 'Blackboard KET Web Enhanced',
	'BL': 'Online w/Possible Campus Visit',
	'BP': 'On Campus w/Online Content',
	'BR': 'Blackboard Web World Plato',
	'BT': 'Blackboard KET Web World',
	'BU': 'Blackboard KET Web Local',
	'BW': 'Online & Open to All Students',
	'CC': 'Cablecast',
	'CO': 'Correspondence',
	'CT': 'Interactive TV Class on Campus',
	'CW': 'Cablecast/Web Enhanced',
	'DR': 'Directed Research',
	'HB': 'Partially Online & InClassroom',
	'HI': 'Partially Online & ITV Class',
	'HK': 'Blackboard KET Hybrid',
	'HP': 'Blackboard Hybrid Plato',
	'IA': 'ITV Web Enhanced/Angel',
	'IB': 'Independ Stdy w/Online Content',
	'IS': 'Independent Studies',
	'IW': 'ITV Web Enhanced/WebCT',
	'JP': 'In Person/PLATO/JCCAhrens',
	'KA': 'KET Web Enhanced/Angel',
	'KE': 'KET/Teleweb',
	'KT': 'KET',
	'KW': 'KET/Web Enhanced/WebCT',
	'LA': 'Web Local/Angel',
	'LC': 'Online w/Set Meeting Time',
	'LP': 'Web Class Local/*WebCT*/PLATO',
	'P': 'On Campus Classroom',
	'PA': 'In Person/Web Enhanced/Angel',
	'PP': 'In Person/Plato',
	'PW': 'In Person/Web Enhanced/WebCT',
	'TV': 'Television',
	'VC': 'Web Class/*Angel*/PLATO',
	'VL': 'Online-Self Select Start Date',
	'1VP': 'Web Class/*Web CT*/PLATO',
	'VT': 'Videotape',
	'WA': 'Web Class/Angel',
	'WC': 'In Person/*Angel*/PLATO',
	'WL': 'Web Class Local/WebCT',
	'WP': 'In Person/*Web CT*/PLATO',
	'WW': 'Web Class/WebCT',
};
